import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-lg container-fluid list_partners" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("section", { class: "header d-none" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "text-primary" }, " Need: Improve Treatment Support For TB Patients "),
  /*#__PURE__*/_createElementVNode("h6", { class: "text-primary" }, " Video Treatment Support (VOT) for TB Patients Via Mobiles ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_List = _resolveComponent("List")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_Timeline = _resolveComponent("Timeline")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Files = _resolveComponent("Files")!
  const _component_TabView = _resolveComponent("TabView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_TabView, { ref: "MyInnovationTab" }, {
      default: _withCtx(() => [
        _createVNode(_component_TabPanel, { header: "List of partners" }, {
          default: _withCtx(() => [
            _createVNode(_component_List)
          ]),
          _: 1
        }),
        _createVNode(_component_TabPanel, { header: "Innovation timeline" }, {
          default: _withCtx(() => [
            _createVNode(_component_Timeline)
          ]),
          _: 1
        }),
        _createVNode(_component_TabPanel, { header: "Message" }, {
          default: _withCtx(() => [
            _createVNode(_component_Message)
          ]),
          _: 1
        }),
        _createVNode(_component_TabPanel, { header: "Files" }, {
          default: _withCtx(() => [
            _createVNode(_component_Files)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512)
  ]))
}